import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ENTRY_STORE_STATE_KEY } from './entry.reducer';
import { EntryStoreState } from './entry.model';

const EntryStoreState = createFeatureSelector<EntryStoreState>(
  ENTRY_STORE_STATE_KEY
);

export const EntrySelectors = {
  state: EntryStoreState,
  accession: createSelector(
    EntryStoreState,
    (state: EntryStoreState) => state.accession
  ),
  uniprotAccession: createSelector(
    EntryStoreState,
    (state: EntryStoreState) => state.uniprotAccession
  ),
  isUniProt: createSelector(
    EntryStoreState,
    (state: EntryStoreState) => state.isUniProt
  ),
  providerData: createSelector(
    EntryStoreState,
    (state: EntryStoreState) => state.providerData
  ),
  entryData: createSelector(
    EntryStoreState,
    (state: EntryStoreState) => state.entryData
  ),
  csvAmData: createSelector(
    EntryStoreState,
    (state: EntryStoreState) => state.csvAmData
  ),
  tedDomainData: createSelector(
    EntryStoreState,
    (state: EntryStoreState) => state.tedDomainData
  ),
  clustermmseqData: createSelector(
    EntryStoreState,
    (state: EntryStoreState) => state.clustermmseqData
  ),
  clusterfoldseekData: createSelector(
    EntryStoreState,
    (state: EntryStoreState) => state.clusterfoldseekData
  ),
  uniprotData: createSelector(
    EntryStoreState,
    (state: EntryStoreState) => state.uniprotData
  ),
};
